<!-- 组件说明 -->
<template>
  <div class="new_order">
    <container title="訂單資訊">
      <div v-for="item in orderGoods" :key="item.id" :name="item">
        <van-card
          :title="item.prodName"
          :desc="item.desc"
          :num="item.num"
          :price="formatPrice(item.selectedSkuPrice)"
          :thumb="item.pic"
        >
          <div slot="bottom">
            <div class="sku">{{item.selectedSkuName}}</div>
          </div>
        </van-card>
      </div>
    </container>
    <container class="top" title="选择送货及付款方式">
      <div>
        <div class="item_name">送货地点</div>
        <div class="item_value" @click="locationPop = true">
          <span>台灣</span>
          <van-icon name="arrow-down" />
        </div>
        <div :class="['item_name','top']">送貨方式</div>
        <div class="item_value" @click="sendPop = true">
          <span>{{getSendName(sendValue)}}</span>
          <van-icon name="arrow-down" />
        </div>
        <!-- <div class="top">注意事項：</div>
        <div>● 鞋款數量大於2雙或服飾大於4件時，請改用宅配。</div>
        <div>● 收件地址請詳細填寫，若縣市內有XX區、XX鎮，例：中正區、後龍鎮等，請務必填寫。</div>
        <div>●收件人姓名請務必填寫中文全名，若有『收件人中文姓名不全』或『英文或它國語言暱稱』導致物流配送困難退件，該筆訂單經物流退回本公司，將會延長再次送件時程。</div>
        <div>● 訂單成立後，包裹將於1-3個工作天內寄出。</div>
        <div>● 爲方便您查詢訂單，請填寫您的電子信箱，如果沒有電子信箱可填寫a@aa.com</div>
        <div :class="['item_name','top']">付款方式</div>
        <div class="item_value" @click="payPop = true">
          <span>{{getGetItem(getValue)}}</span>
          <van-icon name="arrow-down" />
        </div> -->
      </div>
    </container>
    <container class="top" title="訂單資訊">
      <div class="order_item">
        <span>小計:</span>
        <span>{{$t('Pay.money')}}{{totalPrice(orderGoods)}}</span>
      </div>
      <div :class="['order_item','top']">
        <span>運費:</span>
        <span>{{$t('Pay.money')}} 0</span>
      </div>
      <van-divider></van-divider>
      <div :class="['order_item']">
        <span>合計({{orderGoods.length}})件</span>
        <span>{{$t('Pay.money')}} {{totalPrice(orderGoods)}}</span>
      </div>
      <van-button type="primary" class="top" size="large" @click="enterOrder3">前往結帳</van-button>
    </container>
    <van-popup v-model="locationPop" class="pop">
      <van-radio-group v-model="locationValue">
        <van-radio class="radio_item" name="1">台灣</van-radio>
      </van-radio-group>
    </van-popup>
    <van-popup v-model="sendPop" class="pop">
      <van-radio-group v-model="sendValue">
        <van-radio
          v-for="(item,index) in sendItems"
          :key="index"
          class="radio_item"
          :name="item.id"
        >{{item.name}}</van-radio>
      </van-radio-group>
    </van-popup>
    <van-popup v-model="payPop" class="pop">
      <van-radio-group v-model="getValue">
        <van-radio
          v-for="(item,index) in getItems"
          :key="index"
          class="radio_item"
          :name="item.id"
        >{{item.name}}</van-radio>
      </van-radio-group>
    </van-popup>
  </div>
</template>

<script>
import Container from '@/components/container';
import { moneys } from "../../static/moneyString"
export default {
  components: { Container },
  data() {
    return {
      moneysString:'',
      sendItems: [
        {
          id: '1',
          name: '全家 取貨付款',
        },
        {
          id: '2',
          name: '7-11 取貨付款',
        },
        {
          id: '3',
          name: '黑貓宅配',
        },
      ],
      getItems: [
        {
          id: '1',
          name: '全家 取貨付款',
        },
        {
          id: '2',
          name: '7-11 取貨付款',
        },
      ],
      locationPop: false,
      sendPop: false,
      payPop: false,
      locationValue: '1',
      sendValue: '1',
      getValue: '1',
    };
  },
  computed: {
    orderGoods: {
      get() {
        return this.$store.state.goods.orderGoods;
        
      },
      set(val) {},
    },
  },
  filters: {},
  methods: {
    totalPrice(goods) {
      return goods.reduce((total, item) => total + item.selectedSkuPrice * item.num, 0);
    },
    getSendName(id) {
      return this.sendItems[Number(id) - 1].name;
    },
    getGetItem(id) {
      return this.getItems[Number(id) - 1].name;
    },
    enterOrder3() {
      this.$session.set(
        'order',
        JSON.stringify({
          getValue: this.getValue,
        }),
      );
      this.$router.push('orderStep3');
    },
    formatPrice(price) {
      return price;
    },
  },
  created() {
    //生命周期 - 创建完成
    var str=this.$session.get('moneyString');
    this.moneysString=moneys[str];
  },
  destroyed() {
    //生命周期 - 销毁完成
  },
};
</script>

<style lang='scss' scoped>
.new_order {
  padding: 0.8rem;
  box-sizing: border-box;
  .van-card {
    background: #fff;
  }
}
.item_value {
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 0.6rem;
  margin-top: 0.08rem;
  height: 1.2rem;
  border-radius: 0.12rem;
  justify-content: space-between;
  border: 1px #ddd solid;
}
.top {
  margin-top: 0.88rem;
}
.pop {
  width: 10rem;
  border-radius: 0.12rem;
  padding: 0.4rem 0.8rem 1.2rem 0.8rem;
  .radio_item {
    margin-top: 0.8rem;
  }
}
.order_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/pages/NewOrder.vue